<template>
  <div class="preloader">
      <div class="preloader-body">
        <div class="loader-container">
          <img src="@/assets/your-loader.gif" alt="Loading..." class="loader-gif">
        </div>
        <p v-if="text1">{{ text1 }}...</p>
      </div>
    </div>
</template>

<script>
export default {
  data(){
    return{
      seatmap:"",
      confirm:"",
      text1:""
    }
  },
  mounted(){
    let router = this.$route;
    console.log(this.$router,router,'router')
    if(router.path == "/seatmap"){
      this.text1 = "We're searching for the best available seats for you. Please wait while we load the seat selection."
    }
    else if(router.path == "/confirmBook"){
      this.text1 = "Please wait while we confirm your price. This may take a few minutes."
    }
  }
}
</script>

<style>
@import "@/assets/style.css";

.loader-container {
  width: 100%;
  height: auto;
  text-align: center;
  margin-bottom: 20px;
}

.loader-gif {
  width: 150px;
  height: 150px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

.preloader {
  position: fixed !important;
  left: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  right: 0 !important;
  z-index: 10000 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  background: #fff !important;
  transition: none !important;
}

</style>